import { render, staticRenderFns } from "./SelectPalette.vue?vue&type=template&id=00148200&"
import script from "./SelectPalette.vue?vue&type=script&lang=js&"
export * from "./SelectPalette.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports